import { Button, useDisclosure } from '@chakra-ui/react';

import { WebPushPermissionGuide } from './WebPushPermissionGuide';

export function WebPushPermissionHelp() {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Button size="sm" variant="outline" onClick={onOpen}>
        Pengaturan notifikasi browser
      </Button>
      <WebPushPermissionGuide isOpen={isOpen} onClose={onClose} />
    </>
  );
}
